export interface NavItem {
  label: string
  href: string
  note?: string
}

export interface NavSection {
  label: string
  /** The hub's own page — always the first link in the dropdown too. */
  href: string
  overviewLabel?: string
  items?: NavItem[]
  /** A single highlighted link at the foot of the panel. */
  feature?: { label: string; blurb: string; href: string }
}

export const navigation: NavSection[] = [
  {
    label: 'Things to do',
    href: '/things-to-do',
    overviewLabel: 'All things to do',
    items: [
      { label: 'Attractions', href: '/attractions', note: '22 places' },
      { label: 'Parks & playgrounds', href: '/parks', note: '41 parks' },
      { label: 'Beaches with kids', href: '/beaches', note: '12 beaches' },
      { label: 'Libraries & storytimes', href: '/blog', note: '9 branches' },
      { label: 'Rainy day ideas', href: '/blog', note: '18 ideas' },
      { label: 'Free things to do', href: '/blog', note: '35 places' },
      { label: 'Birthday party places', href: '/birthday-parties', note: '24 venues' },
    ],
    feature: {
      label: 'Santa Barbara Zoo',
      blurb: 'Timing, membership math and where to park.',
      href: '/place',
    },
  },
  {
    label: 'Events',
    href: '/events',
    overviewLabel: 'Full events calendar',
    items: [
      { label: 'This weekend', href: '/events', note: 'Updated Thursdays' },
      { label: 'Annual events', href: '/events', note: 'Fiesta, Solstice, parades' },
      { label: 'Seasonal guides', href: '/blog', note: 'From the blog' },
      { label: 'Submit an event', href: '/events', note: 'Free, always' },
    ],
  },
  {
    label: 'Classes & sports',
    href: '/classes',
    overviewLabel: 'All classes & sports',
    items: [
      { label: 'Swim lessons', href: '/classes', note: '14 programs' },
      { label: 'Dance', href: '/classes', note: '11 studios' },
      { label: 'Gymnastics', href: '/classes', note: '6 gyms' },
      { label: 'Soccer & team sports', href: '/classes', note: '9 leagues' },
      { label: 'Music', href: '/classes', note: '13 programs' },
      { label: 'Martial arts', href: '/classes', note: '10 dojos' },
    ],
    feature: {
      label: 'Registration open now',
      blurb: 'Three sign-up windows closing this month.',
      href: '/classes',
    },
  },
  {
    label: 'For parents',
    href: '/for-parents',
    overviewLabel: 'All parent resources',
    items: [
      { label: 'Preschools, daycares & elementary', href: '/for-parents', note: '48 schools' },
      { label: 'Childcare & babysitters', href: '/for-parents', note: '11 options' },
      { label: 'Family photographers', href: '/for-parents', note: '14 pros' },
      { label: 'Parent groups & meetups', href: '/for-parents', note: '19 groups' },
      { label: 'Pregnancy & postpartum', href: '/for-parents', note: '14 providers' },
      { label: 'Kids health & therapy', href: '/for-parents', note: '22 providers' },
      { label: 'Support & counseling', href: '/for-parents', note: '16 services' },
      { label: 'Fitness with childcare', href: '/for-parents', note: '12 gyms' },
    ],
    feature: {
      label: 'SBCC Parenting Program',
      blurb: 'Free drop-in classes, birth through pre-K.',
      href: '/place',
    },
  },
  {
    label: 'Shop & eat',
    href: '/things-to-do',
    overviewLabel: 'All shops & eats',
    items: [
      { label: 'Kid-friendly restaurants', href: '/things-to-do', note: '15 spots' },
      { label: 'Toy stores', href: '/things-to-do', note: '8 shops' },
      { label: 'Kids clothes & resale', href: '/things-to-do', note: '10 shops' },
      { label: 'The SB Family Edit', href: '/about', note: 'Our picks' },
    ],
  },
  {
    label: 'Blog',
    href: '/blog',
  },
  {
    label: 'About',
    href: '/about',
    overviewLabel: 'About Santa Barbara With Kids',
    items: [
      { label: 'Our story', href: '/about', note: '' },
      { label: 'How we test & rank', href: '/about', note: '' },
      { label: 'Advertise or partner', href: '/about', note: '' },
      { label: 'Submit an event', href: '/events', note: '' },
      { label: 'Site plan', href: '/site-structure', note: 'For this rebuild' },
    ],
  },
]
